import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Box, Typography, Divider, useMediaQuery, IconButton, Icon } from '@mui/material'

// Local imports
import AdxDrawerComponent from 'components/reusable/drawer/AdxDrawerComponent'
import BalanceList from '../components/list'
import BalanceDetails from '../components/details'

const LeaveBalanceDrawer = ({ leaveBalanceList, backgroundLocation, initialSelected }) => {
  const navigate = useNavigate()
  const isNotLarge = useMediaQuery((theme) => theme.breakpoints.down('lg'))
  const [activeDisplay, setActiveDisplay] = useState('LIST')
  const [drawerState, setDrawerState] = useState({ right: true })
  const handleDrawer = (anchor, open) => (event) => {
    setDrawerState({ ...drawerState, [anchor]: open })
    navigate(-1)
  }
  const [selectedLeaveBalance, setSelectedLeaveBalance] = useState(
    leaveBalanceList[initialSelected.type][initialSelected.index]
  )
  const [selectedWithEntitlementValue, setSelectedWithEntitlementValue] = useState(
    initialSelected.detail
  )

  const handleSelectLeave = (withEntitlement, id) => {
    if (isNotLarge) {
      setActiveDisplay('PANEL')
    }
    if (withEntitlement === 1) {
      setSelectedLeaveBalance(leaveBalanceList['with_entitlement'].find((item) => item.id === id))
      setSelectedWithEntitlementValue('WITH')
    } else if (withEntitlement === 2) {
      setSelectedLeaveBalance(
        leaveBalanceList['without_entitlement'].find((item) => item.id === id)
      )
      setSelectedWithEntitlementValue('WITHOUT')
    } else {
      setSelectedLeaveBalance(leaveBalanceList.leave_credit[0])
      setSelectedWithEntitlementValue('REPLACEMENT')
    }
  }

  return (
    <AdxDrawerComponent
      state={drawerState}
      anchor="right"
      onClose={handleDrawer}
      headerprops
      title={selectedLeaveBalance.leave_policy.name}
      sx={{ width: { xs: '100%', lg: '1200px' }, p: 0 }}
    >
      <Box sx={{ width: '100%', display: 'flex' }}>
        <Box
          sx={{
            display: {
              xs: activeDisplay === 'PANEL' ? 'none' : 'block',
              lg: 'block',
            },
            width: { xs: '100%', lg: '490px' },
            mt: '-85px',
          }}
        >
          <BalanceList
            list={leaveBalanceList}
            selectedList={selectedLeaveBalance}
            handleSelectLeave={handleSelectLeave}
          />
        </Box>
        <Box
          sx={{
            display: {
              xs: activeDisplay === 'PANEL' ? 'block' : 'none',
              lg: 'block',
            },
            width: { xs: '100%', lg: 'calc(100% - 490px)' },
          }}
        >
          <BalanceDetails
            backgroundLocation={backgroundLocation}
            selectedList={selectedLeaveBalance}
            withEntitlement={selectedWithEntitlementValue}
          />
        </Box>
      </Box>
    </AdxDrawerComponent>
  )
}

export default LeaveBalanceDrawer
